/**
 * intent-labels — rótulos pt-BR (display-only) para a taxonomia canônica de
 * ações do conductor (`IntentAction` em `@lume/shared/identity-assurance/
 * intent-actions.ts`). Vive no FE porque é texto de UI voltado ao operador; a
 * fonte da verdade da taxonomia continua em `@lume/shared`.
 *
 * O `action` que o backend devolve é lenient (`z.string()` no
 * `intentClassificationSchema` — model-agnóstico): uma ação fora da taxonomia
 * cai no fallback honesto (devolve a própria string), nunca quebra.
 */

import { isIntentAction } from '@lume/shared';

import type { IntentAction } from '@lume/shared';

const INTENT_ACTION_LABELS: Record<IntentAction, string> = {
  public_info: 'Informação pública',
  account_context: 'Contexto da conta',
  sensitive_data_read: 'Consulta de dado sensível',
  billing_payment_code_read: 'Código de pagamento',
  service_status_read: 'Consulta de status de serviço',
  service_connection_read: 'Diagnóstico de conexão',
  service_ticket_read: 'Status de chamado',
  cadastral_change: 'Alteração cadastral',
  service_action: 'Ação de serviço',
  appointment_confirm: 'Confirmação de visita',
  // Frente B Bloco II — agenda nativa.
  agenda_availability_query: 'Consulta de disponibilidade',
  agenda_book: 'Agendamento',
  agenda_reschedule: 'Remarcação',
  agenda_cancel: 'Cancelamento de agenda',
  // Frente B Bloco IV — grupo/capacidade/fila de espera.
  service_slots_query: 'Consulta de vagas',
  agenda_join_waitlist: 'Entrar na fila de espera',
  out_of_scope: 'Fora de escopo',
};

/** Rótulo pt-BR da ação; fallback honesto à string crua para ações off-taxonomy. */
export function labelForIntentAction(action: string): string {
  return isIntentAction(action) ? INTENT_ACTION_LABELS[action] : action;
}
